export const hrmCardStyles = {
    section: {
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        padding: "16px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    },
    sectionSoft: {
        backgroundColor: "#ffffff",
        borderRadius: "14px",
        padding: "14px",
        border: "1px solid rgba(148, 163, 184, 0.35)",
        boxShadow: "0 1px 2px rgba(2,6,23,0.06)",
    },
    stat: {
        backgroundColor: "#ffffff",
        borderRadius: "8px",
        padding: "12px",
    }
};

export const hrmProfileStyles = {
    headerWrap: {
        borderRadius: "16px",
        padding: "16px",
        border: "1px solid rgba(148, 163, 184, 0.35)",
        background: "linear-gradient(135deg, rgba(16,185,129,0.14), rgba(56,189,248,0.14))",
        boxShadow: "0 8px 24px rgba(2,6,23,0.08)",
    },
    headerWrapDark: {
        borderRadius: "16px",
        padding: "16px",
        border: "1px solid rgba(51, 65, 85, 0.9)",
        background: "linear-gradient(135deg, rgba(16,185,129,0.10), rgba(56,189,248,0.10))",
        boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
    },
    avatar: {
        width: 72,
        height: 72,
        borderRadius: "9999px",
        objectFit: "cover" as const,
        border: "2px solid rgba(255,255,255,0.7)",
        backgroundColor: "rgba(148, 163, 184, 0.20)",
        boxShadow: "0 6px 18px rgba(2,6,23,0.18)",
    },
};

export const hrmGridStyles = {
    grid: {
        display: "grid",
        gap: "16px",
    }
};

export const hrmChipStyles = {
    base: {
        padding: "4px 8px",
        borderRadius: "16px",
        fontSize: "12px",
    }
};

export const createIconBadgeStyles = (color: string) => ({
    backgroundColor: `${color}1A`,
    color: color,
    padding: "8px",
    borderRadius: "8px",
});
